import { useQuery } from "@tanstack/react-query";
import { getSKUOptions_latest } from "services/data.internal.service";
import { getLocationOptions } from "services/data.internal.service";
import { getCustWhOptions } from "services/data.internal.service";
import { getZoneOptions } from "services/data.internal.service";
import { getVendorOptionsWithName } from "services/data.internal.service";
import { getCustWhSetting, getVendorOptions } from "services/data.internal.service";

export const useCustWhSettingQuery = ({ customerCode, ...query }) => {
  const enabled = Boolean(customerCode);
  return useQuery({
    queryKey: ["cust-wh-setting", { customerCode }],
    queryFn: () => getCustWhSetting({ customerCode }),
    enabled,
    ...query
  });
};

export const useVendorOptions = ({ customerCode, enabled, onSuccess, onError }) => {
  let isEnabled = enabled;
  if (isEnabled === undefined) {
    isEnabled = Boolean(customerCode);
  }
  return useQuery({
    queryKey: ["vendor-options", { customerCode }],
    queryFn: () => getVendorOptions({ custCode: customerCode }),
    enabled: isEnabled,
    onSuccess,
    onError,
  });
};

export const useVendorOptionsWithName = ({ customerCode, enabled, ...query }) => {
  let isEnabled = enabled;
  if (isEnabled === undefined) {
    isEnabled = Boolean(customerCode);
  }
  return useQuery({
    queryKey: ["vendor-name-options", { customerCode }],
    queryFn: () => getVendorOptionsWithName({ customerCode }),
    enabled: isEnabled,
    ...query,
  });
};

export const useLocationOptionsQuery = ({
  queryKey = "location-options",
  whCode,
  zoneID,
  enabled,
  ...query
}) => {
  let isEnabled = enabled;
  if (enabled === undefined) {
    isEnabled = Boolean(whCode) && Boolean(zoneID);
  }
  return useQuery({
    queryKey: [queryKey, { whCode, zoneID }],
    queryFn: () => getLocationOptions({ whCode, zoneID }),
    enabled: isEnabled,
    ...query,
  });
};
export const useWhOptionsQuery = ({ ...query }) => {
  return useQuery({
    queryKey: ["warehouse-options"],
    queryFn: () => getWarehouseOptions(),
    ...query,
  });
};

export const useZoneOptionsQuery = ({
  queryKey = "zone-options",
  whCode,
  zoneType = "all",
  enabled,
  ...query
}) => {
  let isEnabled = enabled;
  if (isEnabled === undefined) {
    isEnabled = Boolean(whCode);
  }
  return useQuery({
    queryKey: [queryKey, { whCode, zoneType }],
    queryFn: () => getZoneOptions({ whCode, zoneType }),
    enabled: isEnabled,
    ...query,
  });
};

export const useSKUOptions = ({ customerCode, ...query }) => {
  return useQuery({
    queryKey: ["sku-options", { customerCode }],
    queryFn: () => getSKUOptions_latest({ customerCode }),
    enabled: Boolean(customerCode),
    ...query,
  });
};

export const useCustWhOptionsQuery = ({ customerCode, enabled, ...query }) => {
  let isEnabled = enabled;
  if (isEnabled === undefined) {
    isEnabled = Boolean(customerCode);
  }
  return useQuery({
    queryKey: ["cust-wh-options", { customerCode }],
    queryFn: () => getCustWhOptions({ customerCode }),
    enabled: isEnabled,
    ...query,
  });
};
